module.exports = __webpack_public_path__ + "static/percentage-a76662a05a872de573bcad572d5ddfd2.jpg";